"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const andes_react_1 = require("@yonderland/andes-react");
const Slider_1 = require("../components/slider/Slider");
const cotopaxi_1 = require("@as/cotopaxi");
const react_i18next_1 = require("react-i18next");
const i18nConstants_1 = require("../constants/i18nConstants");
const common_utils_1 = require("@as-react/common-utils");
const SLIDES_TO_SCROLL = 1;
const sliderConfig = {
    displayCroppedSlides: false,
    hideOnViewports: false,
    infiniteSliding: false,
    innerSpacing: true,
    showArrowsForDesktop: true,
    showIndicators: false,
    slidesToScrollMobile: SLIDES_TO_SCROLL,
    slidesToScrollMobileLarge: SLIDES_TO_SCROLL,
    slidesToScrollTabletSmall: SLIDES_TO_SCROLL,
    slidesToScrollTablet: SLIDES_TO_SCROLL,
    slidesToScrollDesktop: SLIDES_TO_SCROLL,
    slidesToScrollDesktopLarge: SLIDES_TO_SCROLL,
    slidesToShowMobile: 1.25,
    slidesToShowMobileLarge: 1.25,
    slidesToShowTabletSmall: 3.25,
    slidesToShowTablet: 3.25,
    slidesToShowDesktop: 3.8,
    slidesToShowDesktopLarge: 3.8,
};
const AuthorLinkedContentPagesContainer = (data) => {
    const { t } = (0, react_i18next_1.useTranslation)([i18nConstants_1.I18N_NAMESPACES.general]);
    const contentTileTranslations = {
        readMore: t(`${i18nConstants_1.I18N_NAMESPACES.general}:readMore`),
    };
    if (!data || data.contentPages.length === 0) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(andes_react_1.Box, { paddingBlock: { base: '10', md: '12', xl: '16' }, children: (0, jsx_runtime_1.jsxs)(andes_react_1.StackBlock, { gap: '6', children: [(data === null || data === void 0 ? void 0 : data.name) && ((0, jsx_runtime_1.jsx)(andes_react_1.TextAlpha, { color: 'emphasised', variant: 'headingS', children: t('author.page.articles.title', {
                        name: data.name,
                    }) })), (0, jsx_runtime_1.jsx)(Slider_1.Slider, { properties: sliderConfig, id: 'author-articles-slider', children: data.contentPages.map((slide, index) => ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(cotopaxi_1.ContentTile, { href: slide.url || '/', title: slide.title || '', text: slide.shortDescription || '', tags: slide.tags || [], translations: contentTileTranslations, image: (0, common_utils_1.isNullOrUndefined)(slide.image.imagePath)
                                ? { src: '' }
                                : {
                                    src: slide.image.imagePath,
                                    isPicture: true,
                                    lazy: true,
                                }, withoutSpacing: true }) }, `slide_component_${index}}`))) })] }) }));
};
exports.default = AuthorLinkedContentPagesContainer;
